import CalculatorInput from './calculatorInput';
import css from './index.module.scss';
import { calcultorList } from '@/constants/calculatorModule';
import { useGlobal } from '@/utils/useGlobal';
import EfModal from '@/components/UI/Modal';

export default function CalculatorModule() {
    const { useLang, Link, useRouter, useState, useEffect, isMobile } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstation');
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const [open, setOpen] = useState(false);
    const [hrs, setHrs] = useState(0);

    const getBatteryLife = (life: any) => {
        if (typeof life === 'string') {
            const newValue = (Number(life) * 10 * 3) / 10;
            setHrs(newValue);
        } else {
            setHrs(0);
        }
    };

    return (
        <div
            className={`${isMobile ? css.calculatorModuleH5 : css.calculatorModule} calculatorModule GtmModuleData-section`}
            data-section-id={css.calculatorModule}
            data-section-title={t('delta2.calculator_title')}
        >
            <div className="title">{t('delta2.calculator_title')}</div>
            <div className="desc">{t('delta2.calculator_desc1')}</div>
            <div className="desc last-desc">
                {t.rich('delta2.calculator_desc2', {
                    p1: (str) => (
                        <span className="click-ele" onClick={() => setOpen(true)}>
                            {str}
                        </span>
                    ),
                })}
            </div>
            <CalculatorInput getBatteryLife={getBatteryLife} />
            <div className="buy-tips-content">
                <div className="battery-tips1">
                    {t.rich('delta2.calculator_battery_tips1', {
                        p1: () => <span className="hrs-color">{hrs}Hrs</span>,
                    })}
                </div>
                <div className="battery-tips2">{t('delta2.calculator_battery_tips2')}</div>
            </div>
            <EfModal
                open={open}
                visible={open}
                width={isMobile ? '100%' : 620}
                className={isMobile ? css.calculatorModalH5 : css.calculatorModal}
                classNames={{
                    wrapper: 'calculatorModalWrapH5',
                }}
                onCancel={() => setOpen(false)}
            >
                <div className={'modal'}>
                    <div className="input-content">
                        <CalculatorInput />
                    </div>
                    <div className="list">
                        <div className="table-head row">
                            <span>{t('delta2.calculator_modal_appliances')}</span>
                            <span className="middle">{t('delta2.calculator_modal_watts')}</span>
                            <span className="last">{t('delta2.calculator_modal_delta2')}</span>
                        </div>
                        <ul className="table-body">
                            {calcultorList.map((item: any, index: number) => (
                                <li className="table-item row" key={index}>
                                    <span>{item.appliance}</span>
                                    <span className="middle">{item.watts}</span>
                                    <span className="last">{item.delta2}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </EfModal>
        </div>
    );
}
